<template>
  <div class="lbv-message-list animated fadeIn roundedCard">
    <div class="row">
      <div class="col-lg-12">
        <b-card>
          <h1 class="lbv-page-title">
            Message List
          </h1>
          <b-row class="align-items-center secondary message-list-filters">
            <b-col
              md="3"
            >
              <b-form-group
                label="Tenant"
                label-for="tenant-id"
              >
                <b-input-group>
                  <b-form-select
                    id="tenant-id"
                    v-model="selectedTenant"
                    class="full-width"
                  >
                    <option :value="null">
                      All
                    </option>
                    <option
                      v-for="tenant in tenants"
                      v-bind="$attrs"
                      :key="tenant.id"
                      :value="tenant.id"
                      @option="$emit('option', $event.target.value)"
                    >
                      {{ tenant.name }}
                    </option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              md="2"
            >
              <b-form-group
                label="Code"
                label-for="code"
              >
                <b-input-group>
                  <b-form-select
                    id="code"
                    v-model="selectedCode"
                    :options="emailCodes"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              md="2"
            >
              <b-form-group
                label="Type"
                label-for="type"
              >
                <b-input-group>
                  <b-form-select
                    id="type"
                    v-model="selectedType"
                    :options="commType"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              md="2"
            >
              <b-form-group
                label="Lang"
                label-for="lang"
              >
                <b-input-group>
                  <b-form-select
                    id="lang"
                    v-model="selectedLanguage"
                    :options="languages"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              md="3"
              class="mb-3 d-flex"
            >
              <b-button
                id="applyBtn"
                variant="primary"
                class="w-100 mr-3"
                @click="applyFilters"
              >
                Apply
              </b-button>
              <b-button
                id="exportButton"
                variant="primary"
                class="w-100 mr-3"
                @click="downloadExport"
              >
                Export
              </b-button>
              <b-button
                id="addButton"
                variant="primary"
                class="w-100"
                @click="addNew"
              >
                Add
              </b-button>
            </b-col>
          </b-row>
          <b-table
            striped
            hover
            responsive
            :items="paginatedList"
            :fields="fields"
          >
            <template
              slot="emailCode"
              slot-scope="data"
            >
              <b-link
                class="deviceLink"
                @click="showEmail(data)"
              >
                {{ data.value }}
              </b-link>
            </template>
          </b-table>
          <b-button
            class="page prev"
            variant="primary"
            size="sm"
            :disabled="currentPage === 1"
            @click.prevent="page"
          >
            Prev
          </b-button>

          <b-button
            class="page next"
            variant="primary"
            size="sm"
            :disabled="!hasNextPage"
            @click.prevent="page"
          >
            Next
          </b-button>
          <div class="current-page">
            Page: {{ currentPage }}
          </div>
        </b-card>
        <b-modal
          id="email-view"
          ref="emailView"
          title="View Message"
          ok-variant="primary"
          ok-title="Update"
          :ok-disabled="!hasUpdates"
          @ok="save"
        >
          <div class="col-md-12">
            <b-form-group
              horizontal
              label="Subject:"
              :label-cols="2"
            >
              <b-form-input
                v-model="updatedSubject"
                class="col-md-10"
                type="text"
              />
            </b-form-group>
            <b-form-group
              horizontal
              label="Body:"
              :label-cols="2"
            >
              <b-form-textarea
                v-model="updatedBody"
                class="col-md-10"
                rows="10"
                max-rows="20"
              />
            </b-form-group>
            <b-form-group
              horizontal
              label=""
              :label-cols="2"
            >
              <b-button
                class="col-md-2"
                size="sm"
                variant="secondary"
                @click="preview"
              >
                Preview
              </b-button>
            </b-form-group>
            <b-form-group
              horizontal
              label="Tokens:"
              :label-cols="2"
            >
              <b-form-input
                v-model="updatedTokens"
                class="col-md-10"
                type="text"
              />
            </b-form-group>
          </div>
        </b-modal>
        <b-modal
          id="add-new"
          ref="addNewView"
          title="Add New Message"
          ok-variant="primary"
          ok-title="Save"
          @ok="save"
          @cancel="closeDialog"
          @hidden="closeDialog"
        >
          <div class="col-md-12">
            <b-form-group
              horizontal
              label="Tenant:"
              :label-cols="2"
            >
              <b-form-select
                id="selectTenants"
                v-model="selectedTenant"
                class="full-width"
              >
                <option :value="null">
                  All
                </option>
                <option
                  v-for="tenant in tenants"
                  v-bind="$attrs"
                  :key="tenant.id"
                  :value="tenant.id"
                  @option="$emit('option', $event.target.value)"
                >
                  {{ tenant.name }}
                </option>
              </b-form-select>
            </b-form-group>
            <b-form-group
              horizontal
              label="Type:"
              :label-cols="2"
            >
              <b-form-select
                v-model="selectedType"
                :options="commType"
              />
            </b-form-group>
            <b-form-group
              horizontal
              label="Lang:"
              :label-cols="2"
            >
              <b-form-select
                v-model="selectedLanguage"
                :options="languages"
              />
            </b-form-group>
            <b-form-group
              horizontal
              label="Code:"
              :label-cols="2"
            >
              <b-form-select
                v-model="selectedCode"
                :options="emailCodes"
              />
            </b-form-group>
            <b-form-group
              horizontal
              label="Subject:"
              :label-cols="2"
            >
              <b-form-input
                v-model="updatedSubject"
                type="text"
              />
            </b-form-group>
            <b-form-group
              id="bodyInput"
              horizontal
              label="Body:"
              :label-cols="2"
              label-text-align="top"
            >
              <b-form-textarea
                v-model="updatedBody"
                rows="8"
                max-rows="8"
              />
            </b-form-group>
            <b-form-group
              horizontal
              label=""
              :label-cols="2"
            >
              <b-button
                class="col-md-3"
                size="sm"
                variant="secondary"
                @click="preview"
              >
                Preview
              </b-button>
            </b-form-group>
            <b-form-group
              horizontal
              label="Tokens:"
              :label-cols="2"
            >
              <b-form-input
                v-model="updatedTokens"
                type="text"
              />
            </b-form-group>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import messageListMixin from '../mixins/messageListMixin'

export default {
  name: 'MessageList',
  mixins: [messageListMixin]
}
</script>

<style>
  .lbv-device-list #applyBtn, .lbv-device-list #addButton, .lbv-device-list #exportButton {
    margin-top: 10px;
  }

  #email-view .modal-dialog{
    max-width: 800px !important;
  }

  #bodyInput .col-form-label {
    align-items: baseline;
  }

  .lbv-message-list .current-page {
    margin-top: -20px;
  }

  .lbv-message-list .message-list-filters {
    margin: 0px 0px;
    border-bottom: 1px solid #C7CFCA;
    background-color: rgba(242, 242, 242, 1);
  }

  td.width-100 {
    width: 100px;
    max-width: 100px;
  }

  td.width-250 {
    width: 250px;
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .lbv-message-list #applyBtn, .lbv-message-list #exportButton, .lbv-message-list #addButton {
    margin-top: 10px;
 }

</style>
